"use client";
import { IBlocks } from "@/types";
import { Input } from "@/components/ui/input";
import React from "react";
import { replaceProtocolWithHTTPS, startsWithHTTPS } from "@/lib/utils";
import { toast } from "sonner";
import CardSetting from "@/components/admin/settings/CardSetting";
interface Props {
    block: IBlocks;
    blockUpdate: React.Dispatch<React.SetStateAction<IBlocks>>;
    update: (value: IBlocks) => void;
}
export default function SpotifyOptions({ block, blockUpdate, update }: Props) {
    const [oldBlock, setOldBlock] = React.useState(block);
    const [url, setUrl] = React.useState(block.url);
    return (
        <CardSetting
            noBorder
            title="Share URL"
            description="On Spotify, click 'Share' and choose the 'Copy Link' option."
        >
            <div className="flex w-full flex-col gap-3">
                <Input
                    variant="card"
                    className="w-full"
                    type="text"
                    value={url}
                    onChange={(e) => {
                        setUrl(e.target.value);
                        blockUpdate({
                            ...block,
                            url: e.target.value,
                        });
                    }}
                    onBlur={(e) => {
                        if (!startsWithHTTPS(e.target.value)) {
                            e.target.value = replaceProtocolWithHTTPS(
                                e.target.value
                            );
                            setUrl(e.target.value);
                            blockUpdate({
                                ...block,
                                url: e.target.value,
                            });
                        }
                        if (oldBlock.url != e.target.value) {
                            update({
                                ...block,
                                url: e.target.value,
                            });
                            setOldBlock({
                                ...oldBlock,
                                url: e.target.value,
                            });
                        }
                    }}
                />
            </div>
        </CardSetting>
    );
}
